import { render, staticRenderFns } from "./classManage.vue?vue&type=template&id=4d737294&"
import script from "./classManage.vue?vue&type=script&lang=js&"
export * from "./classManage.vue?vue&type=script&lang=js&"
import style0 from "./classManage.vue?vue&type=style&index=0&id=4d737294&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports